import { render } from "./CompanyChangeView.vue?vue&type=template&id=675d4465&scoped=true"
import script from "./CompanyChangeView.vue?vue&type=script&lang=js"
export * from "./CompanyChangeView.vue?vue&type=script&lang=js"

import "./CompanyChangeView.vue?vue&type=style&index=0&id=675d4465&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675d4465"]])

export default __exports__